// extracted by mini-css-extract-plugin
export default {"link":"SidebarLink--link--2148ee","isSelected":"SidebarLink--isSelected--5807d3","selected":"SidebarLink--selected--0bc2b5","icon":"SidebarLink--icon--d1b50a"};